import { createMuiTheme } from '@material-ui/core/styles'

const brand = {
  primary: '#0d9488',
  primaryLight: '#14b8a6',
  primaryDark: '#0f766e',
  accent: '#6366f1',
  surface: '#f8fafc',
  paper: '#ffffff',
  text: '#0f172a',
  muted: '#64748b',
  border: '#e2e8f0',
}

export const adminTheme = createMuiTheme({
  palette: {
    primary: {
      main: brand.primary,
      light: brand.primaryLight,
      dark: brand.primaryDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: brand.accent,
      contrastText: '#ffffff',
    },
    background: {
      default: brand.surface,
      paper: brand.paper,
    },
    text: {
      primary: brand.text,
      secondary: brand.muted,
    },
    success: { main: '#10b981' },
    warning: { main: '#f59e0b' },
    error: { main: '#ef4444' },
  },
  typography: {
    fontFamily:
      '"DM Sans", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 600, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 10,
        padding: '8px 18px',
      },
      contained: {
        boxShadow: 'none',
        '&:hover': { boxShadow: '0 4px 14px rgba(13,148,136,0.25)' },
      },
    },
    MuiCard: {
      root: {
        borderRadius: 16,
        border: `1px solid ${brand.border}`,
        boxShadow:
          '0 1px 2px rgba(15,23,42,0.04), 0 8px 24px rgba(15,23,42,0.06)',
      },
    },
    MuiPaper: {
      rounded: { borderRadius: 16 },
      elevation1: {
        boxShadow:
          '0 1px 2px rgba(15,23,42,0.04), 0 4px 16px rgba(15,23,42,0.05)',
      },
    },
    MuiAppBar: {
      colorPrimary: {
        background:
          'linear-gradient(135deg, #0f766e 0%, #0d9488 50%, #14b8a6 100%)',
        boxShadow: '0 4px 20px rgba(13,148,136,0.3)',
      },
    },
    MuiDrawer: {
      paper: {
        borderRight: `1px solid ${brand.border}`,
        backgroundColor: '#ffffff',
      },
    },
    MuiTableCell: {
      head: {
        fontWeight: 600,
        color: brand.muted,
        backgroundColor: '#f8fafc',
      },
    },
    MuiChip: {
      root: { fontWeight: 500 },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
        minHeight: 48,
      },
    },
    MuiLinearProgress: {
      root: { borderRadius: 8, height: 8 },
      bar: { borderRadius: 8 },
    },
  },
})

export default adminTheme
